import { useTranslations } from "@jugl-web/utils";
import { Button } from "@jugl-web/ui-kit";
import { useChatBot } from "@jugl-web/domain-resources/chat-bot/providers/ChatBotProvider/useChatBot";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";

export const Banner = () => {
  const { t } = useTranslations();
  const { show: showChatBot } = useChatBot();
  return (
    <div className="font-secondary flex  w-full max-w-[1000px] flex-col justify-between gap-8 rounded-3xl bg-gradient-to-r from-[#F1F8FF] to-[#FCF8FF] p-12 [@media(min-width:1280px)]:flex-row [@media(min-width:1280px)]:items-center">
      <div className="flex flex-col items-start gap-2 [@media(min-width:1280px)]:gap-4">
        <div className="text-dark text-left text-[28px] font-semibold">
          {t({
            id: "connect-support-banner.title",
            defaultMessage: "Didn't found what you're looking for? 👀",
          })}
        </div>
        <div className="text-dark-700 text-left text-base">
          {t({
            id: "connect-support-banner.subtitle",
            defaultMessage:
              "Connect with our Support Team to get all the answers",
          })}
        </div>
      </div>
      <Button
        variant="primary"
        size="lg"
        onClick={showChatBot}
        className="w-max"
        iconEnd={<ArrowIcon className="fill-white transition-all" />}
      >
        {t({
          id: "connect-support-banner.button",
          defaultMessage: "Contact Support",
        })}
      </Button>
    </div>
  );
};
